import React from 'react'
import HeroIndex from './inicio/HeroIndex'
import Section2 from './inicio/Section2'
import Footer from './Footer'

const Inicio = () => {
  return (
    <>
        <HeroIndex />
        <Section2 />
        <Footer />
    </>
  )
}

export default Inicio